import { SET_CLIENT_SIZE } from './types';

function getClientSize() {
  const width = document.documentElement.clientWidth
    || window.innerWidth
    || document.body.clientWidth;
  const height = document.documentElement.clientHeight
    || window.innerHeight
    || document.body.clientHeight;

  return { width, height };
}

export default function setClientSize() {
  return {
    type: SET_CLIENT_SIZE,
    payload: getClientSize(),
  };
}
